import { useEffect, useState } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { SelectChangeEvent } from "@mui/material";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  CustomButton,
  CustomTable,
  MultipleSelect,
} from "../../../shared/uiComponents";
import { errorNormalizer } from "../../../shared/Helpers/functions";
import { Container } from "../../../components/StyledComponents";
import { downloadFile, ReportFilters } from "../../Reports/helpers";
import SoapNotesHeader from "../soapNotesHeader";
import { Headers, TableBody } from "./tableInfo";

import { DispatchProperties, useSelector } from "../../../redux/store";
import {
  downloadDSUSoapNotes,
  getDSUSoapNotes,
} from "../../../redux/State/clientSlice/soapNoteSlice";
import { GetDSUSoapNotesProperties } from "../../../redux/API/ClientAPIHelpers/soapNoteProperties";

const DSUNotes = () => {
  const dispatch = useDispatch<DispatchProperties>();
  const [params] = useSearchParams();

  const [bcbaNoteStatuses, setBcbaNoteStatuses] = useState<Array<string>>([]);
  const [btNoteStatuses, setBtNoteStatuses] = useState<Array<string>>([]);

  const notes = useSelector((state) => state.soapNote.dsuSoapNotes);
  const loading = useSelector((state) => state.soapNote.loading);
  const {
    clientId,
    endDate,
    startDate,
    userId,
  } = useSelector((state) => state.billing.billingFilters);

  useEffect(() => {
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";
    const direction = params.get("direction") || "";
    const orderBy = params.get("orderBy") || "";
    const searchString = params.get("searchString") || "";

    if (!startDate || !endDate) return;
    const data: GetDSUSoapNotesProperties = {
      page,
      pageSize,
      startDate,
      endDate,
      direction,
      orderBy,
      searchString,
      userId,
      clientId,
      status: bcbaNoteStatuses,
      supervisedStatus: btNoteStatuses,
    };

    dispatch(getDSUSoapNotes(data)).then(unwrapResult).catch(errorNormalizer);
  }, [
    dispatch,
    params,
    bcbaNoteStatuses,
    btNoteStatuses,
    clientId,
    endDate,
    startDate,
    userId,
  ]);

  const donwloadDSUNotesHandler = () => {
    const page = params.get("page") || "1";
    const pageSize = !!notes.totalNumberOfItems
      ? notes.totalNumberOfItems.toString()
      : "8";
    const direction = params.get("direction") || "";
    const orderBy = params.get("orderBy") || "";
    const searchString = params.get("searchString") || "";

    if (!startDate || !endDate) return;
    const data: GetDSUSoapNotesProperties = {
      page,
      pageSize,
      startDate,
      endDate,
      direction,
      orderBy,
      searchString,
      userId,
      clientId,
      status: bcbaNoteStatuses,
      supervisedStatus: btNoteStatuses,
    };

    dispatch(downloadDSUSoapNotes(data))
      .then(unwrapResult)
      .then((response) => downloadFile(response))
      .catch(errorNormalizer);
  };

  const bcbaStatusesHandler = (event: SelectChangeEvent<Array<string>>) => {
    const { value } = event.target;
    if (typeof value === "string") return;
    setBcbaNoteStatuses(value);
  };
  const btStatusesHandler = (event: SelectChangeEvent<Array<string>>) => {
    const { value } = event.target;
    if (typeof value === "string") return;
    setBtNoteStatuses(value);
  };

  return (
    <Container>
      <SoapNotesHeader />
      <ReportFilters showUsers={true} showShorcuts={false} />
      <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
        <MultipleSelect
          label="BCBA SOAP Note Status"
          setValue={bcbaStatusesHandler}
          data={[
            { id: "0", name: "Draft" },
            { id: "1", name: "Submitted" },
            { id: "3", name: "Expired BCBA" },
            { id: "4", name: "Unlocked" },
            { id: "5", name: "Pending BT" },
          ]}
        />
        <MultipleSelect
          label="BT SOAP Note Status"
          setValue={btStatusesHandler}
          data={[
            { id: "-1", name: "Not Created" },
            { id: "0", name: "Draft" },
            { id: "1", name: "Submitted" },
            { id: "2", name: "Expired BT" },
            { id: "4", name: "Unlocked" },
          ]}
        />
        <CustomButton
          onClick={donwloadDSUNotesHandler}
          title={"Download"}
          loading={loading}
          className="marginTop16"
        />
      </div>
      <CustomTable
        headers={Headers}
        TableBody={TableBody}
        data={notes}
        loading={loading}
        hasMobile={false}
      />
    </Container>
  );
};

export default DSUNotes;
